module.exports = __webpack_public_path__ + "static/media/72.23ec2f7f.png";